import { Button, message, Popconfirm } from 'antd'
import { CargoApi } from '../../../../api/Purchase/Cargo'
import CreateCargoModal from '../../../../components/Purchasing/Packages/CreateCargoModal'
import useModalData from '../../../../elements/Hooks/useModalData'
import React from 'react'
import { withRouter } from 'react-router-dom'

function CreateCargoCont({ selection, selectionRawData, history }) {
  const {
    visible,
    modalType,
    object: packageObj,
    setObject: setPackage,
    submitting,
    checkForm,
    formRef,
    onShow,
    onCancel,
    setSubmitting,
    isNew,
  } = useModalData()

  async function submit() {
    let newObject = await checkForm()
    newObject.packages = selection.map((o) => o._id)
    setSubmitting(true)
    try {
      const data = await CargoApi.create(newObject)
      history.replace({
        pathname: `/purchasing/cargo/${data._key}/update`,
      })
      message.success('Success')
    } catch (e) {
      console.error(e)
      message.error(e.errorMessage || e)
    }
    setSubmitting(false)
  }

  return (
    <>
      <Popconfirm
        placement="left"
        title={`Please be aware that this will create a Cargo with a single Package.  \n Do you wish to proceed ?`}
        onConfirm={onShow}
        okText="Yes"
        cancelText="No">
        <Button type={'primary'} size="small" icon={'plus'}>
          Create Cargo
        </Button>
      </Popconfirm>
      <CreateCargoModal
        {...{
          visible,
          modalType,
          selection,
          cargo: {},
          fetching: false,
          // cargo: packageObj,
          // setCargo: setPackage,
          submitting,
          formRef,
          onShow,
          onCancel,
          setSubmitting,
          isNew,
          submit,
        }}
      />
    </>
  )
}

export default withRouter(CreateCargoCont)
